import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../layouts/Navbar";
import Sidebar from "../../layouts/Sidebar";
import axios from "axios";
import Preloader from "../../components/Preloader";
import { FaEdit, FaUserCheck } from "react-icons/fa";
import { BsX } from "react-icons/bs";
import "./AdminAttendance.css";

const AdminAttendance = () => {
  const api = process.env.REACT_APP_API;
  const apikey = process.env.REACT_APP_KEY;

  const navi = useNavigate();
  const [viewData, setViewData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState("");

  // ---------- PHOTO MODAL STATE ----------
  const [photoModal, setPhotoModal] = useState({
    visible: false,
    animate: false,
    photo: null,
  });

  // ---------- ATTENDANCE MODAL STATE ----------
  const [attendanceModal, setAttendanceModal] = useState({
    visible: false,
    animate: false,
    employee: null,
  });

  // ---------- FETCH EMPLOYEE DATA ----------
  useEffect(() => {
    const getUserDetails = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${api}/Admin/viewemployee`, {
          headers: { apikey },
        });
        setViewData(response.data.data || []);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    getUserDetails();
  }, []);

  const markAttendance = async (status, userid) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${api}/attendance/mark`,
        { status, userid },
        { headers: { apikey } }
      );

      alert(`${attendanceModal.employee.name} marked ${status}`);
      closeAttendanceModal();
    } catch (err) {
      console.error(err);
      alert("Failed to mark attendance");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Preloader />;

  // ---------- FILTER DATA ----------
  const filteredData = viewData.filter((item) => {
    const query = search.toLowerCase();

    return (
      item.name.toLowerCase().includes(query) ||
      item.phonenumber.toString().includes(query) ||
      item.employee_code.toLowerCase().includes(query) ||
      item.userid.toString().includes(query)
    );
  });

  // ---------- PHOTO MODAL ----------
  const openPhotoModal = (photo) => {
    setPhotoModal({ visible: true, animate: false, photo });
    setTimeout(() => setPhotoModal((prev) => ({ ...prev, animate: true })), 10);
  };

  const closePhotoModal = () => {
    setPhotoModal((prev) => ({ ...prev, animate: false }));
    setTimeout(
      () => setPhotoModal({ visible: false, animate: false, photo: null }),
      300
    );
  };

  // ---------- ATTENDANCE MODAL ----------
  const openAttendanceModal = (employee) => {
    setAttendanceModal({ visible: true, animate: false, employee });
    setTimeout(
      () => setAttendanceModal((prev) => ({ ...prev, animate: true })),
      10
    );
  };

  const closeAttendanceModal = () => {
    setAttendanceModal((prev) => ({ ...prev, animate: false }));
    setTimeout(
      () =>
        setAttendanceModal({ visible: false, animate: false, employee: null }),
      300
    );
  };

  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper d-flex">
        <Sidebar />
        <div className="main-panel">
          <div style={{ padding: "1%", backgroundColor: "white" }}>

            {/* SEARCH BAR */}
            <div style={{ marginBottom: "20px" }}>
              <input
                type="text"
                className="form-control"
                placeholder=" 🔍 Search by name, phone number, employee code or user ID"
                style={{maxWidth:"300px"}}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            <div style={{overflowX:'auto'}}>
                <table className="table table-striped" style={{ overflowX: "auto" }}>
              <thead>
                <tr>
                  <th>S No</th>
                  <th>Name</th>
                  <th>Phone Number</th>
                  <th>Photo</th>
                  <th>Employee Code</th>
                  <th>User ID</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((item, index) => (
                    <tr key={item.userid}>
                      <td>{index + 1}</td>
                      <td>{item.name}</td>
                      <td>{item.phonenumber}</td>
                      <td>
                        <img
                          className="employee-photo"
                          onClick={() =>
                            openPhotoModal(`${api}/uploads/${item.photo}`)
                          }
                          src={
                            item.photo
                              ? `${api}/uploads/${item.photo}`
                              : "/default-avatar.png"
                          }
                          alt={item.name}
                        />
                      </td>
                      <td>{item.employee_code}</td>
                      <td>{item.userid}</td>
                      <td>
                        <button
                          className="btn btn-success btn-sm"
                          onClick={() => openAttendanceModal(item)}
                        >
                          <FaUserCheck />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center text-muted">
                      No matching employee found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            </div>
          </div>
        </div>
      </div>

      {/* PHOTO MODAL */}
      {photoModal.visible && (
        <div
          className={`AdminAttendance_photoModal ${
            photoModal.animate ? "AdminAttendance_modal-show" : ""
          }`}
        >
          <div className="AdminAttendance_modal-content">
            <div className="AdminAttendance_modal-header">
              <BsX
                className="AdminAttendance_close-btn"
                onClick={closePhotoModal}
              />
            </div>
            <img
              src={photoModal.photo}
              alt="Employee"
              className="AdminAttendance_modal-photo"
            />
          </div>
        </div>
      )}

      {/* ATTENDANCE MODAL */}
      {attendanceModal.visible && (
        <div
          className={`AdminAttendance_attendanceModal ${
            attendanceModal.animate ? "AdminAttendance_modal-show" : ""
          }`}
        >
          <div className="AdminAttendance_modal-content">
            <div className="AdminAttendance_modal-header">
              <BsX
                className="AdminAttendance_close-btn"
                onClick={closeAttendanceModal}
              />
            </div>
            {attendanceModal.employee && (
              <div className="AdminAttendance_modal-body attendance-body">
                <img
                  src={
                    attendanceModal.employee.photo
                      ? `${api}/uploads/${attendanceModal.employee.photo}`
                      : "/default-avatar.png"
                  }
                  alt={attendanceModal.employee.name}
                  className="modal-employee-photo"
                />
                <h4>{attendanceModal.employee.name}</h4>
                <p>{attendanceModal.employee.employee_code}</p>
                <div className="attendance-buttons">
                  <button
                    className="btn btn-success"
                    onClick={() =>
                      markAttendance("Present", attendanceModal.employee.userid)
                    }
                  >
                    Present
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() =>
                      markAttendance("Absent", attendanceModal.employee.userid)
                    }
                  >
                    Absent
                  </button>
                  <button
                    className="btn btn-warning"
                    onClick={() =>
                      markAttendance(
                        "Half-Day",
                        attendanceModal.employee.userid
                      )
                    }
                  >
                    Half-Day
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminAttendance;
